export default __webpack_public_path__ + "static/media/angels_blessing.37dd8517.png";